import script from "./PreviewBody.vue?vue&type=script&setup=true&lang=ts"
export * from "./PreviewBody.vue?vue&type=script&setup=true&lang=ts"

import "./PreviewBody.vue?vue&type=style&index=0&id=23133799&lang=scss"

const __exports__ = script;

export default __exports__